<div class="container py-5 text-center">
    <div class="card shadow-sm border-0 p-4">
      <h1 class="display-4 fw-bold text-danger mb-3">404</h1>
      <h2 class="fw-bold text-dark mb-3">Page Not Found</h2>
      <p class="text-muted mb-4">
        Oops! The page you're looking for doesn't exist or has been moved.
      </p>
     
    </div>
  </div>
  